import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import useAuth from '../hooks/useAuth';
import { PATH_DASHBOARD } from '../routes/paths';

type RoleBasedGuardProp = {
  accessibleRoles: (string | number)[];
  children: ReactNode | string;
};

const useCurrentRole = (): string | number | null => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  // Check for registeredRole (number) - primary role identifier
  if (user.registeredRole !== undefined && user.registeredRole !== null) {
    return user.registeredRole;
  }

  // Fallback: check for role (string) if registeredRole is not available
  if (user.role) {
    return user.role;
  }

  return null;
};

export default function RoleBasedGuard({ accessibleRoles, children }: RoleBasedGuardProp) {
  const currentRole = useCurrentRole();

  if (currentRole === null || !accessibleRoles.includes(currentRole)) {
    return <Navigate to={PATH_DASHBOARD.overview.root} replace />;
  }

  return <>{children}</>;
}
